module.exports = __webpack_public_path__ + "static/media/frost_mastery.c097a0cd.png";